// extracted by mini-css-extract-plugin
export default {"container":"Table_container__-UV1h","table":"Table_table__bH7L3","headers":"Table_headers__IJFOE","skeleton":"Table_skeleton__TkXjz"};